<template>
    <div class="ddheader" :class="{ isActive:isActive }">
        <div class="header_container" :class="{ fixed: fixed == 1 }">
            <header class="header">
                <a class="back iconfont" @click="goBack">&#xe667;</a>
                <div class="h_label line1">
                    {{ titleText }}
                </div>
                <a :class="{ active: isActive }" class="menu" @click="loadNav"></a>
            </header>
            <nav :class="{ active: isActive }" class="t-nav">
                <ul>
                    <li><a :href="env.VUE_APP_MDD_index" class="home">首页</a></li>
                    <li><a :href="env.VUE_APP_MDD_search" class="search">搜索</a></li>
                    <li><a :href="env.VUE_APP_MDD_category" class="category">分类</a></li>
                    <li><a :href="env.VUE_APP_MDD_cart" class="cart">购物车</a></li>
                    <li><a :href="env.VUE_APP_MDD_my" class="user">我的当当</a></li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
/* global headUrl */
/* eslint no-undef: "error" */
export default {
    name: "ddheader",
    props: {
        title: {
            type: String,
            default: "",
        },
        fixed: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isActive: false,
            env: {},
        };
    },
    created() {
        this.env = process.env;
    },
    computed: {
        titleText() {
            return this.title;
        },
    },
    methods: {
        loadNav() {
            this.isActive = !this.isActive;
        },
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style scoped lang="less">
/** 顶部导航 **/
.ddheader {
    display: flex;
    justify-content: center;
    height: 88px;
    transition: height 0.3s;
    .header_container {
        width: 750px;
        .header {
            background-color: #ffffff;
            color: #333333;
            display: flex;
            border-bottom: 1px solid #d8d8d8;
            height: 88px;
            .back {
                width: 88px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 30px;
            }
            .h_label {
                flex: 1;
                font-size: 34px;
                line-height:88px;
                text-align: center;
            }
            .menu {
                width: 88px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: url(//img62.ddimg.cn/upload_img/00610/h5m/menu-1597204393.png) no-repeat center;
                background-size: 44px;
                transition: background-image 0.3s;
            }
            .menu.active {
                background-image: url(//img60.ddimg.cn/upload_img/00610/h5m/menu-active-1597204356.png);
                background-size: 0.32rem;
            }
            .menu.active:after {
                content: "";
                display: block;
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 0.14rem;
                background: url(//img61.ddimg.cn/upload_img/00610/h5m/connect-1597204229.png) no-repeat center 0;
            }
        }
        .t-nav {
            width: 100%;
            height: 0;
            overflow: hidden;
            text-align: center;
            line-height: 0;
            background-color: #eee;
            font-size: 0.2rem;
            transition: height 0.3s;
            ul {
                display: flex;
                li {
                    flex: 1;
                    a {
                        display: inline-block;
                        width: 100%;
                        padding: 0.35rem 0 0.04rem;
                        background: url(//img63.ddimg.cn/upload_img/00610/h5m/h-home-1597204275.png) no-repeat center 0.12rem;
                        background-size: 0.44rem;
                        line-height: 0.8rem;
                        color: #4d525d;
                        box-sizing: border-box;
                        height: 100px;
                    }
                    .home {
                        background-image: url(//img63.ddimg.cn/upload_img/00610/h5m/h-home-1597204275.png);
                    }
                    .search {
                        background-image: url(//img63.ddimg.cn/upload_img/00610/h5m/h-search-1597204316.png);
                    }
                    .category {
                        background-image: url(//img63.ddimg.cn/upload_img/00610/h5m/h-category-1597204296.png);
                    }
                    .cart {
                        background-image: url(//img62.ddimg.cn/upload_img/00610/h5m/h-cart-1597204248.png);
                    }
                    .user {
                        background-image: url(//img62.ddimg.cn/upload_img/00610/h5m/h-user-1597204334.png);
                    }
                }
            }
        }
        .t-nav.active {
            height: 1rem;
            border-bottom: 1px solid #d8d8d8;
        }
    }
    .fixed {
        position: fixed;
        margin: 0 auto;
        left: auto;
        right: auto;
        top:0;
        z-index:99;
    }
    &.isActive{
        // height:188px;
    }
}
</style>
